import {
  ENV,
  Environment,
  mockServerPort,
} from '@backoffice-frontend/environment'

const VehicleDeviceManagementStages: Record<Environment, string> = {
  [Environment.local]: `https://1ed0uk06o2.execute-api.eu-central-1.amazonaws.com/dev/vdm/api/v1/internal`,
  [Environment.test]: `http://localhost:${mockServerPort}/api/vehicle-device-management`,
  [Environment.development]:
    'https://1ed0uk06o2.execute-api.eu-central-1.amazonaws.com/dev/vdm/api/v1/internal',
  [Environment.integration]:
    'https://1ed0uk06o2.execute-api.eu-central-1.amazonaws.com/dev/vdm/api/v1/internal',
  [Environment.production]:
    'https://1ed0uk06o2.execute-api.eu-central-1.amazonaws.com/dev/vdm/api/v1/internal',
  [Environment['production.us-east-1']]:
    'https://1ed0uk06o2.execute-api.eu-central-1.amazonaws.com/dev/vdm/api/v1/internal',
}

const Host = VehicleDeviceManagementStages[ENV]

export const VehicleDeviceManagementAreaEndpoints = {
  Host,
  Base: `${Host}`,
  Vehicles: {
    List: `${Host}/vehicles`,
    Get: `${Host}/vehicle`,
    Infleet: `${Host}/vehicle/infleet`,
  },
  Onboarding: {
    ByVin: `${Host}/onboarding`,
  },
}
